// A fila é da rota-pai (`admin.bug-reports.tsx`), porque ela continua desenhada embaixo quando
// o reporte abre no drawer. Esta rota-índice existe só para `/admin/bug-reports` ser um
// destino válido do roteador.

import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/admin/bug-reports/')({ component: () => null });
